<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
    <path
      fill="#1976d2"
      d="M20,28H8c-1.105,0-2-0.895-2-2V8c0-1.105,0.895-2,2-2h12c1.105,0,2,0.895,2,2v18   C22,27.105,21.105,28,20,28z"
    />
    <path
      fill="#2196f3"
      d="M40,16H28c-1.105,0-2-0.895-2-2V8c0-1.105,0.895-2,2-2h12c1.105,0,2,0.895,2,2v6 C42,15.105,41.105,16,40,16z"
    />
    <path
      fill="#2196f3"
      d="M20,42H8c-1.105,0-2-0.895-2-2v-6c0-1.105,0.895-2,2-2h12c1.105,0,2,0.895,2,2v6 C22,41.105,21.105,42,20,42z"
    />
    <path
      fill="#1976d2"
      d="M40,42H28c-1.105,0-2-0.895-2-2V22c0-1.105,0.895-2,2-2h12c1.105,0,2,0.895,2,2v18   C42,41.105,41.105,42,40,42z"
    />
    <title v-if="title !== ''">{{ title }}</title>
  </svg>
</template>

<script>
export default {
  name: "DashboardIcon",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>
